<template>
  <section class="plastic">
    <p>
      Необходимо чётко представлять, что алюминиевая прослойка в металлополимерных трубах не несёт никаких функций по обеспечению долговечности или повышению рабочих параметров. Жидкость внутри трубы течёт по каналу из сшитого полиэтилена, а не алюминия.
      Основная задача слоя алюминиевой фольги - препятствовать проникновению кислорода, и вторичная - частично компенсировать температурное расширение. При расчёте систем отопления из металлополимерных труб необходимо руководствоваться данными по долговечности труб из сшитого полиэтилена.
    </p>
    <p>
      В результате комбинации металла и полимеров удалось достичь стойкости труб к заиливанию и зарастанию, устойчивости к коррозии и агрессивным средам, а также антитоксичности. Срок службы металлопластиковых труб составляет порядка 50 лет. В силу незначительного веса и
      высокой пластичности, металлопластиковые трубы просто и удобно монтировать своими руками. Для их обработки требуется минимум инструментов, а сами трубы можно заливать в бетон без ограничений. Ещё одно преимущество металлопластиковых труб - отличная
      ремонтопригодность без потребности применения трубогибочного и сварочного оборудования.
    </p>
    <p>
      При всех своих достоинствах, металлопластиковые трубы не лишены и недостатков. Металл и пластик обладают различными коэффициентами расширения, поэтому постоянные перепады температуры жидкости в трубах могут приводить к ослаблению мест соединений труб, что может вызвать появление протечек.
    </p>
  </section>
</template>

<script>
  export default {

  }
</script>

<style scoped>

p {
  text-align: justify;
  text-indent: 50px;
  padding: 10px;
  font-size: 2em;
  max-width: 1600px;
}

@media (max-width: 1400px) {
  p {
    margin-right: 5%;
    margin-left: 5%;
  }
}

@media (max-width: 800px) {
  p {
    font-size: 1.2em;
  }
}

@media (max-width: 400px) {
  p {
    font-size: 1em;
  }
}

</style>